import { Button, Container } from "react-bootstrap";
import ParticleBackground from "./Particles";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Landing from "./Landing";
import LobbyBrowser from "./LobbyBrowser";
import Privacy from "./Privacy";
import { Header, Footer } from "./Layout";

export default function App() {
    return (
        <div className="bg-background text-foreground min-vh-100 d-flex flex-column">
            <ParticleBackground />
            <Container className="px-3 px-sm-4 py-4 flex-grow-1">
                <Header />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/codes" element={<LobbyBrowser />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route
                        path="/https"
                        element={
                            <Button href="amongus://init?servername=skeld.net&serverport=22030&serverip=https://play.skeld.net&usedtls=false"></Button>
                        }
                    />
                </Routes>
            </Container>
            <Footer />
        </div>
    );
}
